import Swiper from 'swiper';

import 'swiper/css';

import _ from '@app/utils.js'
import {Navigation} from "swiper/modules";

_.onElementReady('.page-node-type-homepage #everyday', el => {
  function updateWidth() {
    const gutter = 12
    const gap = document.querySelector('.container').offsetLeft + gutter
    el.style.width = 'calc(100% + ' + gap + 'px)'
  }
  updateWidth()
  window.addEventListener('resize', updateWidth)
})

_.onElementReady('.page-node-type-homepage #everyday .swiper', el => {
  const swiper = new Swiper(el, {
    modules: [Navigation],
    slidesPerView: 1.4,
    spaceBetween: 16,
    breakpoints: {
      576: {slidesPerView: 2.2, spaceBetween: 24},
      768: {slidesPerView: 3, spaceBetween: 30},
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
})


_.onElementReady('.page-node-type-homepage',() => {
  const section = document.querySelector('#everyday')
  const menuLinks = document.querySelectorAll('.side-menu a')

  window.addEventListener('scroll', () => {
    menuLinks.forEach(link => {
      const sectionRect = section.getBoundingClientRect()
      const linkRect = link.getBoundingClientRect()
      const offset = link.offsetHeight / 2
      const overlap = !(sectionRect.bottom < linkRect.top-offset || sectionRect.top > linkRect.bottom-offset)
      if(overlap) {
        link.classList.add('overlap')
      }
      else {
        link.classList.remove('overlap')
      }
    })


  })
})
